export default {
    pollsUrl: "https://pollsplatform.com",
    baseUrl: "https://site.pollsplatform.com",
    privacy: "privacy",
    terms: "terms",
    feedbackAddress: "feedback@pollsplatform.com",
    getPolls: "https://polls.app.link/t0EFxf38Lob",
}
